// extracted by mini-css-extract-plugin
export default {"contents2":"wrapper_contents2__-1arZ"};